"use client";

import { Content, Header } from "@/components/shared/public/blogs";
import { useTranslations } from "next-intl";
import {
  header,
  section1,
  section10,
  section11,
  section12,
  section13,
  section14,
  section15,
  section16,
  section17,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
} from "../../../../../../public/images/blogs/realEstateAgent";

export default function BlogContent() {
  const t = useTranslations("blogs.realEstateAgent");

  return (
    <>
      <Header
        title={t("header.title")}
        text={t("header.text")}
        src={header}
        alt={t("header.imageAlt")}
      />
      <div className="gs--blog-body flex flex-col gap-10 py-16">
        <Content
          imageFit="cover"
          title={t("sections.section1.title")}
          text={t.rich("sections.section1.text", {
            br: () => <br></br>,
          })}
          src={section1}
          alt={t("sections.section1.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section2.title")}
          text={t.rich("sections.section2.text", {
            br: () => <br></br>,
          })}
          src={section2}
          alt={t("sections.section2.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section3.title")}
          text={t.rich("sections.section3.text", {
            br: () => <br></br>,
          })}
          src={section3}
          alt={t("sections.section3.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section4.title")}
          text={t.rich("sections.section4.text", {
            br: () => <br></br>,
          })}
          src={section4}
          alt={t("sections.section4.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section5.title")}
          text={t.rich("sections.section5.text", {
            br: () => <br></br>,
          })}
          src={section5}
          alt={t("sections.section5.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section6.title")}
          text={t.rich("sections.section6.text", {
            br: () => <br></br>,
          })}
          src={section6}
          alt={t("sections.section6.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section7.title")}
          text={t.rich("sections.section7.text", {
            br: () => <br></br>,
          })}
          src={section7}
          alt={t("sections.section7.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section8.title")}
          text={t.rich("sections.section8.text", {
            br: () => <br></br>,
          })}
          src={section8}
          alt={t("sections.section8.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section9.title")}
          text={t.rich("sections.section9.text", {
            br: () => <br></br>,
          })}
          src={section9}
          alt={t("sections.section9.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section10.title")}
          text={t.rich("sections.section10.text", {
            br: () => <br></br>,
          })}
          src={section10}
          alt={t("sections.section10.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section11.title")}
          text={t.rich("sections.section11.text", {
            br: () => <br></br>,
          })}
          src={section11}
          alt={t("sections.section11.imageAlt")}
          imageLeft={true}
        />
        <Content
          title={t("sections.section12.title")}
          text={t.rich("sections.section12.text", {
            br: () => <br></br>,
          })}
          src={section12}
          alt={t("sections.section12.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section13.title")}
          text={t.rich("sections.section13.text", {
            br: () => <br></br>,
          })}
          src={section13}
          alt={t("sections.section13.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section14.title")}
          text={t.rich("sections.section14.text", {
            br: () => <br></br>,
          })}
          src={section14}
          alt={t("sections.section14.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section15.title")}
          text={t.rich("sections.section15.text", {
            br: () => <br></br>,
          })}
          src={section15}
          alt={t("sections.section15.imageAlt")}
          imageLeft={true}
        />
        <Content
          imageFit="cover"
          title={t("sections.section16.title")}
          text={t.rich("sections.section16.text", {
            br: () => <br></br>,
          })}
          src={section16}
          alt={t("sections.section16.imageAlt")}
        />
        <Content
          imageFit="cover"
          title={t("sections.section17.title")}
          text={t.rich("sections.section17.text", {
            br: () => <br></br>,
          })}
          src={section17}
          alt={t("sections.section17.imageAlt")}
          imageLeft={true}
          disclaimer="default"
        />
      </div>
    </>
  );
}
